<template>
<div class="upload-logotipo">
    <div class="cropper-container-wrapper">
      <div class="cropper-container">
        <UploadFile
          v-show="false"
          :ref="uploadFileRef"
          @input="updateValue"
          :multiple="false"
          :uploadFileRef="uploadFileRef"
          :disabled="disabled"
          :accept="'image/jpeg, image/png'"
        />
        <div class="botoes-verticais" v-show="flagImagemCarregada">
          <div class="botao-quadrado" title="Aumentar Zoom" @click="zoom(1.5)">
            <i class="fas fa-search-plus text-info"></i>
          </div>
          <div class="botao-quadrado" title="Diminuir Zoom" @click="zoom(0.7)">
            <i class="fas fa-search-minus text-info"></i>
          </div>
          <div class="botao-quadrado" title="Centralizar" @click="center()">
            <i class="fa fa-align-center text-info"></i>
          </div>
          <div class="botao-quadrado" title="Restaurar" @click="reset()">
            <i class="fas fa-redo text-info"></i>
          </div>
        </div>
        <cropper
          v-if="exibirLogo"
          :ref="cropperRef"
          class="cropper"
          :src="logoParaPrevisao"
          :transitions="true"
          :debounce="true"
          :resize-image="{ adjustStencil: adjustStencil }"
          :stencil-props="{
            aspectRatio: 10/12,
            movable: true,
            resizable: true
          }"
          :background-wrapper-component="$options.components.CustomBackgroundWrapper"
          @ready="ready"
          :default-size="defaultSize"
          image-restriction="none"
          stencil-component="circle-stencil"
          :background-color="backgroundColor"
        ></cropper>
        <b-img v-if="exibirImagemSemLogo" :blank="true" blankColor="#cccccc" class="img-fluid mb-2 text-center" rounded="circle" width="300" height="300" :src="logoParaPrevisao" alt=""></b-img>
      </div>
    </div>

    <div class="botoes-abaixo">
      <b-button class="botoes" variant="outline-primary btn-sm mt-2 mr-1" :disabled="disabled" @click="abrirComponenteUpload">Alterar</b-button>
      <b-button v-if="exibirLogo" class="botoes" variant="outline-primary btn-sm mt-2" :disabled="disabled" @click="aplicarAjustesNaImagem">Cortar</b-button>
    </div>
    <p v-if="escritorioNaoTemLogo">(Sem logo cadastrada)</p>
  </div>
</template>

<script>
import UploadLogotipo from './js/uploadLogotipo'
export default UploadLogotipo
</script>

<style scoped>
@import './scss/uploadLogotipo.scss';
</style>
